export default "__VITE_ASSET__B0aoA9o8__"